export default "__VITE_ASSET__626acc17__"